import styled from '@emotion/styled';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 80%;
  max-width: 1400px;
  max-height: 80vh;
`;
export const ScrollableContent = styled.div`
  overflow-y: auto;
  max-height: 60vh;
  padding-top: 10px;
`;

export const ModalLoadingContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 900px;
`;

export const CenteredH2 = styled.h2`
  text-align: center;
`;

export const ModalField = styled.div`
  width: 100%;

  input {
    width: 100%;
  }
`;

export const AssignmentTypeSelectContainer = styled.div`
  width: 100%;
  max-width: 150px;
`;

export const RemoveDocumentButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const RemoveDocumentButton = styled.div`
  height: 36px;
`;

export const SubHeadlineSection = styled.div`
  // margin-left: 16px;
  margin-top: 24px;
`;

export const SubHeadlineContainer = styled.div`
  display: flex;
  gap: 20px;
  margin: 12px 0;
`;

export const LinkTypeContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LinkTypeOption = styled.div`
  display: flex;

  label {
    white-space: nowrap;
    margin-left: 4px;
  }
`;

export const AddButtonContainer = styled.div`
  margin-top: 10px;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 12px;
`;

export const ColorOption = styled.div`
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 5px;
  cursor: pointer;
  border: 1px solid #000;
`;

export const DocumentInput = styled.div`
  display: flex;
  gap: 20px;
  // margin-left: 16px;
`;
export const GeneralDocumentPickerContainer = styled.div`
  width: 100%;
`;
